import { colors, fontSize, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const tableWrapper = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const inlineTimeline = css`
  display: grid;
  grid-template-columns: auto 1fr;

  > :last-child {
    border-left: 1px solid ${colors.gray[6]};
  }
`;

export const tableStyle = css`
  max-width: 223px;
  min-width: 223px;
  table-layout: fixed;

  thead th {
    padding-top: 10px;
  }
`;

export const topPagination = css`
  align-self: flex-end;
  padding-bottom: 20px;
`;

export const divider = css`
  width: 510px;
  margin-right: 20px;
  padding-left: 55px;
`;

export const vehicleCell = (isDashcam: boolean) => css`
  && {
    display: inline-flex;
    padding: 19.5px 20px;
    align-items: center;
    justify-content: space-between;
    min-width: 100%;

    > div {
      display: flex;
      align-items: center;

      > span {
        max-width: ${isDashcam ? '153px' : '183px'};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: ${fontSize.lg};
        margin-left: ${isDashcam ? '5px' : '0px'};
      }

      > span b {
        font-weight: ${fontWeight.medium};
      }
    }

    :hover {
      > div {
        > span {
          max-width: ${isDashcam ? '43px' : '65px'};
        }
      }

      > button {
        opacity: 1;
      }
    }

    > button {
      opacity: 0;
    }
  }
`;
